module.exports = __webpack_public_path__ + "img/docx-icon.cbeacc5e.png";